import { render, staticRenderFns } from "./RPFilter.vue?vue&type=template&id=3890cfb6&"
import script from "./RPFilter.vue?vue&type=script&lang=js&"
export * from "./RPFilter.vue?vue&type=script&lang=js&"
import style0 from "./RPFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports